import React from 'react';
import './App.css';
import { dispactConnect, Action, combineAction } from 'combine-action';
// import $ from 'jquery';
// import Script from 'react-load-script'

import Board from './Application/Module/Board'

class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            stop: false
        };
    }

    setLegalMove(e) {
        if (e.data.indexOf("Legal uci moves:") >= 0) {
            const legal = e.data.replace("Legal uci moves:", " ").trim();
            if (!legal) {
                console.log(this.props.logMoves)
                this.props.postMessage(`stop`);
                if (this.props.giliran === 'b') {
                    this.props.updateState({ legalMove1: {}, win: true });
                } else {
                    this.props.updateState({ legalMove1: {}, lose: true });
                }
            } else {
                var legalMove1 = {};
                legal.split(" ").forEach(item => {
                    var c = item.split("");
                    var key = c[0] + c[1];
                    var to = c[2] + c[3];
                    if (legalMove1[key]) {
                        legalMove1[key].push(to);
                    } else {
                        legalMove1[key] = [to];
                    }
                })
                this.props.updateState({ legalMove1 });
            }
        }
    }

    updateSusunan(e) {
        if (e.data.indexOf("Fen: ") >= 0) {
            var susunan = e.data.split(" ");
            //console.log("susunan", susunan)
            this.props.updateState({ susunan: susunan[1], giliran: susunan[2] });
        }
    }

    jalanKomputer(e) {
        if (e.data.indexOf("bestmove") === 0) {// && this.props.giliran === 'b') {
            var jalanKomputer = e.data.split(" ");
            var logMoves = this.props.logMoves;
            if (jalanKomputer[1].indexOf("none") >= 0) {
                return false;
            }
            logMoves.push(jalanKomputer[1]);
            var jl = jalanKomputer[1].split('');
            var jalanLawan = [jl[0] + jl[1], jl[2] + jl[3]];
            this.props.updateState({ logMoves, jalanLawan });

            // this.worker.postMessage(`position startpos moves ${logJoin}`);
            var logJoin = logMoves.join(" ");
            //console.log(`position fen ${this.props.susunanModif} ${this.props.runaway} - - 0 1 moves ${logJoin}`);
            this.worker.postMessage(`position fen ${this.props.susunanModif} ${this.props.runaway} - - 0 1 moves ${logJoin}`);
            this.props.postMessage(`d`);

            if (!this.state.stop) {
                if (this.props.giliran === 'b') {
                    //this.props.postMessage(`go depth 12`);
                } else {
                    //this.props.postMessage(`go depth 12`);
                }
            }
        }
    }

    infoPromosi(e) {
        if (e.data.indexOf("Legal moves:") >= 0) {
            var dataPromosi = e.data.replace("Legal moves:").split(" ");
            if (dataPromosi[1]) {
                var allPromot = {};
                dataPromosi.map(item => {
                    if (item.indexOf('=') > 0) {
                        return { k: item.split('=')[0], v: item.split('=')[1] };
                    } else {
                        return null;
                    }
                })
                    .filter(o => o)
                    .map(item => {
                        if (allPromot[item.k]) {
                            allPromot[item.k].push(item.v);
                        } else {
                            allPromot[item.k] = [item.v];
                        }
                        return item;
                    });
                this.props.updateState({ allPromot });
            }
        }
    }

    componentDidMount() {
        this.worker = new Worker("stockfish6.js");
        this.worker.addEventListener('message', (e) => {
            console.log(e.data);
            this.setLegalMove(e);
            this.updateSusunan(e);
            this.infoPromosi(e);
            this.jalanKomputer(e);
        });
        console.log(this.worker)
        this.worker.postMessage(`position fen ${this.props.susunanModif} w - - 0 1`);
        this.worker.postMessage('d');
        this.props.updateState({ postMessage: (msg) => this.worker.postMessage(msg) });
    }




    render() {
        return (
            <div className="catur">
                <Board {...this.state} formasi={this.props.susunan} />
                <div>Created by: <b>ukungzulfah</b> 🤟🤟🤟</div>
                {/* 
                <button onClick={() => {
                    this.props.updateState({ modeDesain: this.props.modeDesain ? false : true });
                }}>{this.props.modeDesain ? 'APPLY' : 'DESAIN'}</button>

                <button onClick={() => {
                    this.setState({ stop: true })
                }}>STOP</button> */}

            </div>
        );
    }
}

/*

*/

export default dispactConnect((App), combineAction(Action.HomeAction), ['HomeReducer']);
